import React from 'react';
import logoImage from '../../assets/figma/ISentryxLogo.png';

const Logo: React.FC = () => {
  return (
    <div className="flex flex-col items-center">
      <img
        src={logoImage}
        alt="ISentryx"
        className="w-full max-w-72 sm:max-w-sm md:max-w-md h-auto"
        draggable={false}
      />
    </div>
  );
};

export default Logo;